/**
 * Leading Edge brand block for the Inspection Report Dashboard.
 * Renders the gradient logo over the product label. Used on the login
 * screen + as the header brand in the main app shell.
 */

import brandLogo from '../assets/brand-logo.webp';

export function BrandMark({
  product = 'Inspection Report Dashboard',
  compact = false,
}: {
  product?: string;
  compact?: boolean;
}) {
  return (
    <div className={`brand-mark${compact ? ' brand-mark--compact' : ''}`}>
      <img src={brandLogo} alt="Leading Edge — solar & electrical" className="brand-mark__logo" />
      <span className="brand-mark__product">{product}</span>
    </div>
  );
}
